/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Pagination_Morepages1Inputs */

const id_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman lainnya`)
};

const ms_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lagi halaman`)
};

const da_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flere sider`)
};

const de_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Seiten`)
};

const en_us2_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More pages`)
};

const es_es2_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más páginas`)
};

const es_mx2_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más páginas`)
};

const fil_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marami pang pahina`)
};

const fr_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de pages`)
};

const it_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altre pagine`)
};

const hu_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`További oldalak`)
};

const nl_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer pagina's`)
};

const no_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flere sider`)
};

const pl_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Więcej stron`)
};

const pt_br2_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More pages`)
};

const pt_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais páginas`)
};

const ro_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mai multe pagini`)
};

const fi_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää sivuja`)
};

const sv_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fler sidor`)
};

const vi_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm trang`)
};

const tr_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazla sayfa`)
};

const cs_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další stránky`)
};

const bg_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Още страници`)
};

const ru_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Больше страниц`)
};

const uk_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Більше сторінок`)
};

const ar_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المزيد من الصفحات`)
};

const hi_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`और पृष्ठ`)
};

const th_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หน้าอื่น ๆ`)
};

const ja_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他のページ`)
};

const zh_cn2_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More pages`)
};

const zh_hant1_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More pages`)
};

const ko_ui_pagination_morepages1 = /** @type {(inputs: Ui_Pagination_Morepages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More pages`)
};

/**
* | output |
* | --- |
* | "More pages" |
*
* @param {Ui_Pagination_Morepages1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const ui_pagination_morepages1 = /** @type {((inputs?: Ui_Pagination_Morepages1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Pagination_Morepages1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_ui_pagination_morepages1(inputs)
	if (locale === "ms") return ms_ui_pagination_morepages1(inputs)
	if (locale === "da") return da_ui_pagination_morepages1(inputs)
	if (locale === "de") return de_ui_pagination_morepages1(inputs)
	if (locale === "en-US") return en_us2_ui_pagination_morepages1(inputs)
	if (locale === "es-ES") return es_es2_ui_pagination_morepages1(inputs)
	if (locale === "es-MX") return es_mx2_ui_pagination_morepages1(inputs)
	if (locale === "fil") return fil_ui_pagination_morepages1(inputs)
	if (locale === "fr") return fr_ui_pagination_morepages1(inputs)
	if (locale === "it") return it_ui_pagination_morepages1(inputs)
	if (locale === "hu") return hu_ui_pagination_morepages1(inputs)
	if (locale === "nl") return nl_ui_pagination_morepages1(inputs)
	if (locale === "no") return no_ui_pagination_morepages1(inputs)
	if (locale === "pl") return pl_ui_pagination_morepages1(inputs)
	if (locale === "pt-BR") return pt_br2_ui_pagination_morepages1(inputs)
	if (locale === "pt") return pt_ui_pagination_morepages1(inputs)
	if (locale === "ro") return ro_ui_pagination_morepages1(inputs)
	if (locale === "fi") return fi_ui_pagination_morepages1(inputs)
	if (locale === "sv") return sv_ui_pagination_morepages1(inputs)
	if (locale === "vi") return vi_ui_pagination_morepages1(inputs)
	if (locale === "tr") return tr_ui_pagination_morepages1(inputs)
	if (locale === "cs") return cs_ui_pagination_morepages1(inputs)
	if (locale === "bg") return bg_ui_pagination_morepages1(inputs)
	if (locale === "ru") return ru_ui_pagination_morepages1(inputs)
	if (locale === "uk") return uk_ui_pagination_morepages1(inputs)
	if (locale === "ar") return ar_ui_pagination_morepages1(inputs)
	if (locale === "hi") return hi_ui_pagination_morepages1(inputs)
	if (locale === "th") return th_ui_pagination_morepages1(inputs)
	if (locale === "ja") return ja_ui_pagination_morepages1(inputs)
	if (locale === "zh-CN") return zh_cn2_ui_pagination_morepages1(inputs)
	if (locale === "zh-Hant") return zh_hant1_ui_pagination_morepages1(inputs)
	return ko_ui_pagination_morepages1(inputs)
});
export { ui_pagination_morepages1 as "ui.pagination.morePages" }